// 中文文案
export default {
  common: {
    listSeparator: '、',
    companyName: '北京顺势众捷科技有限公司',
    brandName: '顺势众捷',
    altPhone: '电话',
    altAddress: '地址',
    altWechatWork: '企业微信二维码',
    altOfficial: '公众号二维码',
    altProduct: '产品展示',
    altWorkflow: '钟声2.0工作流'
  },
  nav: {
    home: '首页',
    productCenter: '产品中心',
    advantage: '核心优势',
    solution: '应用场景',
    solutionMobile: '解决方案',
    faq: '常见问题',
    about: '关于我们',
    apply: '申请试用',
    applyMobile: '立即申请试用'
  },
  lang: {
    zh: '中文',
    en: 'English'
  },
  solution: {
    common: {
      tryNow: '立即体验',
      industryPainPoints: '行业痛点',
      coreAbilities: '核心能力',
      valueRealization: '价值实现'
    },
    car: {
      title: '汽车',
      bannerTitle: ['AI语音驱动汽车营销', '构建获客-转化-售后全链路增长体系'],
      sectionTitle: 'AI语音赋能汽车营销，重塑数字化客户运营',
      painPoints: [
        { title: '人力双困局', desc: '外呼环节依赖人工坐席，人力成本持续高居不下。' },
        { title: '业务弹性差', desc: '淡旺季人员增减困难，造成资源浪费或响应不及时。' },
        { title: '销售双瓶颈', desc: '订单跟进周期长，人工跟进难；客户比价试驾转化低。' },
        { title: '售后高流失', desc: '保养、预约、续保等依赖人工，跟进不及导致客户流失。' }
      ],
      solutions: [
        {
          title: 'AI智能外呼获客与弹性运营',
          coreAbilities: [
            { title: '高并发智能外呼', desc: 'AI替代人工坐席，单日处理能力无上限，彻底打破人工外呼限制' },
            { title: '灵活外呼时段', desc: '开机即用，随业务需求随时调整外呼时间，轻松应对淡旺季波动' }
          ],
          values: [
            { title: '运营成本趋零', desc: '完全避免人工坐席、招聘、场地、团队管理等综合成本' },
            { title: '业务弹性提升', desc: '打破人工外呼上限，节假日、淡旺季等时间限制，业务发展更灵活' }
          ]
        },
        {
          title: 'AI销售转化与智能数据决策',
          coreAbilities: [
            { title: '通话语义实时分析', desc: '自动生成意向评分与需求标签（价格敏感、竞品对比等）' },
            { title: '数据驱动策略优化', desc: '基于标签聚合分析，精准指导营销话术与产品策略' }
          ],
          values: [
            { title: '销售效率倍增', desc: '接通即掌握用户画像，实时调整话术精准促成交易' },
            { title: '线索零浪费', desc: '低分线索自动进入培育序列，避免任何潜在机会流失' }
          ]
        },
        {
          title: 'AI客户生命周期管理与精准续保',
          coreAbilities: [
            { title: '全量客户批量触达', desc: 'AI覆盖人工难以触及的存量客户群体' },
            { title: '精准营销智能跟进', desc: '基于客户历史数据（车型、保养周期、保险到期日）精准推送' }
          ],
          values: [
            { title: '客户覆盖翻倍', desc: 'AI外呼大幅提升存量客户触达范围与频率' },
            { title: '续保转化倍增', desc: '智能跟进大幅提升续保成功率，促进转化' }
          ]
        }
      ],
      hero: {
        tag: '外呼型AI语音系统',
        titleLine1: '打破人工清洗线索瓶颈',
        titleLine2: '用AI驱动汽车销售新增长',
        descLine1: '通过多轮问答，获取多字段关键信息，一站式解决从生产到交付的全流程',
        descLine2: '助力车企降成本、促发展、提效率，实现合规与收益双保障'
      },
      pain: {
        sectionTitle: '人工电销短板，正在吞噬车企利润',
        items: [
          { title: '管理困难', desc: '缺乏标准化流程，过度依赖个人能力，转化漏斗断层' },
          { title: '效率低下', desc: '销售日均仅打200通/人，时间浪费，高意向客户触达难' },
          { title: '成本高企', desc: '人均每日成本近200元，人力成本投入大但产出转化低' },
          { title: '合规隐患', desc: '授权话术不规范导致授权意向不完整，易导致法律风险。' }
        ]
      },
      flow: {
        sectionTitle: 'AI驱动的汽车线索营销系统',
        sectionSub: '以AI语音应用模型为核心，打造全流程自动化的新车客户邀约与管理平台',
        steps: [
          { title: '智能对话引擎', desc: '拟人化多轮交互，购车意图精准识别' },
          { title: '全流程自动化', desc: '数据接入到回传全自动，采集到线索量化自动化' },
          { title: '数据及时同步', desc: '打通各环节数据流，保障信息一致性' },
          { title: '可配置话术管理', desc: '支持灵活定制对话策略，适应不同场景与品牌风格' },
          { title: '多用户架构支持', desc: '满足多品牌管理需求，支持个性化运营设置' }
        ]
      },
      autoData: {
        sectionTitle: '全流程自动化与智能数据管理',
        left: ['批量线索导入', '一键启动外呼', '全程自动触达'],
        right: ['关键信息提取', '线索清洗分发', '闭环流程管理']
      },
      portrait: {
        sectionTitle: '客户画像构建',
        cards: [
          { icon: 'red', title: '关键字段识别', lines: ['品牌与车系', '省份与城市', '授权信息'] },
          { icon: 'purple', title: '购车行为分析', lines: ['购车时间，识别购车意向用户', '购车方式，区分', '全款、贷款或置换'] },
          { icon: 'red-voice', title: '用户身份标签', lines: ['姓氏提取，个性化称呼', '手机号码，唯一标识', '实现线索追踪与去重'] },
          { icon: 'blue-ai', title: 'AI对话交互', lines: ['多轮对话，逐步确认', '用户真实信息', '准确解析用户表达意图'] },
          { icon: 'green-voice', title: '数据有效性校验', lines: ['过滤玩笑言论，排除明显', '非购车意图内容', '识别非目标人群'] },
          { icon: 'blue-doc', title: '智能去重机制', lines: ['基于手机号，合并相同用户', '防止重复跟进', '行为特征比对'] }
        ]
      },
      sop: {
        sectionTitle: '分级跟进策略 SOP',
        levels: [
          { name: 'A级线索', desc: '高意向立即销售分配跟进' },
          { name: 'B级线索', desc: '中意向24小时内跟进' },
          { name: 'C级线索', desc: '低意向3天内触达培育' }
        ],
        tip: '多维对比',
        scoreTitle: '量化评分',
        rate: '↗ 41.67%',
        radar: ['购车紧迫性', '预算匹配度', '需求明确度', '授权完整性', '历史互动'],
        consult: '立即咨询'
      },
      scene: {
        title: '顺势AI ，汽车线索营销场景全覆盖',
        items: [
          { title: '新车上市邀约', desc: '快速筛选海量线索，精准 识别高意向客户，交由金 牌销售重点跟进。' },
          { title: '车展/大型活动邀约', desc: '进行大规模预热邀约，智 能筛选参会意向，自动发 送活动提醒。' },
          { title: '日常试驾邀约', desc: '自动处理试驾请求，并同 步至销售日程，实现流程 自动化。' },
          { title: '客户关怀与再营销', desc: '定期对C/D级线索进行自 动化触达与培育，低成本 维持客户粘性。' }
        ]
      }
    },
    finance: {
      title: '金融',
      bannerTitle: ['AI语音赋能金融智能服务', '构建营销-风控-催收多场景闭环'],
      sectionTitle: 'AI语音赋能金融核心业务场景，驱动服务智能升级',
      painPoints: [
        { title: '人力成本高昂', desc: '人工坐席日均外呼量不足300通，人力成本占总预算60%以上' },
        { title: '合规风险严峻', desc: '人工话术执行偏差导致客户投诉，触碰金融消费者权益保护红线' },
        { title: '数据利用率低', desc: '大部分机构无法将外呼数据与客户画像、产品持有记录实时联动' },
        { title: '服务效率不足', desc: '传统IVR系统响应缓慢，客户等待时间长，满意度下降' }
      ],
      solutions: [
        {
          title: '智能客服与业务咨询',
          coreAbilities: [
            { title: '7X24小时全天候服务', desc: '支持7×24小时服务，查账、咨询、交易指导等标准化业务' },
            { title: '多维客户感知与智能响应', desc: '感知客户意图、情绪与方言，自动匹配流程并切换安抚话术，减少转接' }
          ],
          values: [
            { title: '服务效率飞跃', desc: '单坐席日均咨询处理量从300通提升至无上限，客户等待时间减少70%' },
            { title: '转接率大幅降低', desc: '大幅降低转接率与客户投诉率，提升自动化水平与客户满意度' }
          ]
        },
        {
          title: '金融产品精准营销',
          coreAbilities: [
            { title: '多维度数据整合分析', desc: '整合交易历史、风险偏好等数据，生成个性化营销话术' },
            { title: '实时策略动态优化', desc: '基于接通率、响应时长等实时数据调整外呼策略' }
          ],
          values: [
            { title: '线索转化率提升', desc: '精准应对不同交互场景，提升外呼转化效率' },
            { title: '高净值客户转化倍增', desc: '产品推荐转化率及复购率显著提升' }
          ]
        },
        {
          title: '风险预警与合规管理',
          coreAbilities: [
            { title: '实时风险智能监测', desc: '自动挖掘对话敏感词与风险事件，即时触发预警' },
            { title: '合规比对与记录留存', desc: '语音内容实时比对，自动提示违规，生成不可篡改记录、决策、操作日志' }
          ],
          values: [
            { title: '欺诈损失有效降低', desc: '异常交易自动识别，月度欺诈损失显著减少' },
            { title: '100%合规保障', desc: '严格遵守法定时段，自动规避禁止时段，历史记录满足金融审计要求' }
          ]
        },
        {
          title: '温情催收与还款提醒',
          coreAbilities: [
            { title: '差异化催收策略引擎', desc: '基于还款能力、逾期天数等制定个性化催收策略' },
            { title: '情感智能分析优化', desc: '实时分析客户情感状态，动态调整话术降低抵触' }
          ],
          values: [
            { title: '催收效率倍增', desc: 'AI日均处理量是人工数十倍，专注复杂案件转化' },
            { title: '还款率显著提升', desc: '智能分析实时调整策略，整体还款率有效提升' }
          ]
        }
      ]
    },
    education: {
      title: '教育',
      bannerTitle: ['AI语音赋能教育', '打通获客-运营链路转化闭环'],
      sectionTitle: 'AI语音赋能教育招生运营，提升全周期转化效率',
      painPoints: [
        { title: '获客成本攀升', desc: '教培行业竞争激烈，传统招生方式效率低下，成本难以控制' },
        { title: '人力效率瓶颈', desc: '招生老师日均外呼量有限，新人培训周期长达2周，流动性大' },
        { title: '服务体验不均', desc: '非工作时间咨询无法及时响应，家长满意度波动较大' },
        { title: '数据断层严重', desc: '学员意向、跟进进度等信息难以系统沉淀，续费转化率低' }
      ],
      solutions: [
        {
          title: 'AI招生拓客与智能线索筛选',
          coreAbilities: [
            { title: '超高并发智能外呼', desc: '支持500+并发，单日处理能力无上限，效率是人工数十倍' },
            { title: '精准意向智能评分', desc: '基于课程需求、预算区间、决策周期三要素精准评分' }
          ],
          values: [
            { title: '招生成本大幅降低', desc: '减少外呼阶段人工坐席成本，实现降本增效' },
            { title: '线索质量显著提升', desc: '高意向客户筛选准确，为持续跟进提高线索转化奠定基础' }
          ]
        },
        {
          title: 'AI学员全生命周期运营与续费管理',
          coreAbilities: [
            { title: '全维度数据整合分析', desc: '整合学员数据、互动记录等多个维度构建统一视图' },
            { title: '智能分群与流失预警', desc: '基于学习行为构建精准画像，自动识别潜在流失学员' }
          ],
          values: [
            { title: '运营人力显著减少', desc: '数据统计准确率提升，人工运营成本有效降低' },
            { title: '续费率有效提升', desc: '基于学习数据推送个性化续费方案，续费率增长' }
          ]
        }
      ]
    },
    insurance: {
      title: '保险',
      bannerTitle: ['AI语音赋能保险智能服务', '覆盖理赔-拓客-回访全业务链路'],
      sectionTitle: 'AI语音赋能保险关键业务场景，提升服务效率与合规水平',
      painPoints: [
        { title: '运营成本日益激增', desc: '保险成本中的营销、人力、流程损耗成本逐年升高' },
        { title: '合规与响应的平衡', desc: '强监管下，合规要求日益严格与动态响应能力失衡' },
        { title: '理赔流程复杂', desc: '人工理赔处理时间长，客户等待周期长，满意度低' },
        { title: '数据孤岛严重', desc: '投保、理赔、服务各环节数据断层，难以实现精细化运营' }
      ],
      solutions: [
        {
          title: 'AI理赔智能通知与全流程自动化',
          coreAbilities: [
            { title: '高拟人TTS语音合成', desc: '接近真人的交互体验，大幅减少人工坐席数量' },
            { title: '理赔流程全自动化', desc: '覆盖报案、审核、赔付全流程的智能化通知' }
          ],
          values: [
            { title: '理赔效率与质量双提升', desc: '人工干预减少，处理效率显著提高' },
            { title: '客户体验与信任度增强', desc: '及时准确的理赔信息推送，提升服务满意度' }
          ]
        },
        {
          title: 'AI精准拓客营销与客户分层运营',
          coreAbilities: [
            { title: '精准客户分层分析', desc: '基于多维度数据智能分层，识别高意向人群' },
            { title: '动态利益点智能匹配', desc: '根据客户画像智能匹配最优方案与建议' }
          ],
          values: [
            { title: '获客成本有效降低', desc: '精准触达减少无效外呼，营销ROI显著提升' },
            { title: '线索转化效率倍增', desc: '高意向客户筛选准确，销售跟进转化率显著提高' }
          ]
        },
        {
          title: 'AI保单智能回访与合规信息采集',
          coreAbilities: [
            { title: '客户意向智能采集', desc: '自动采集反馈与意向，形成可追踪的业务线索' },
            { title: '合规流程自动执行', desc: '标准化流程确保100%合规，零违规记录' }
          ],
          values: [
            { title: '100%合规保障', desc: '全流程质检覆盖，满足监管合规红线要求' },
            { title: '潜在机会深度挖掘', desc: '回访中采集的意向线索利用率显著提升' }
          ]
        }
      ]
    },
    commerce: {
      title: '电商',
      bannerTitle: ['AI语音赋能电商智能运营', '构建销售-私域-售后多链路增长'],
      sectionTitle: 'AI语音赋能电商运营核心场景，提升客户全周期价值',
      painPoints: [
        { title: '人力成本高企', desc: '人员规模庞大，存在明显的波峰波谷需求差异' },
        { title: '转化效率瓶颈', desc: '传统人工外呼转化率低，销售人员日均外呼量有限' },
        { title: '客户流失严重', desc: '跟进不及时、售后响应慢等问题导致满意度下降' },
        { title: '数据孤岛严重', desc: '客户行为、交易、服务等数据分散，营销效果有限' }
      ],
      solutions: [
        {
          title: 'AI销售转化与智能订单挽回',
          coreAbilities: [
            { title: '超高并发弹性外呼', desc: '单日处理能力无上限，应对大促期间海量触达需求' },
            { title: '实时语义意向评分', desc: '通过通话语义分析实时评估购买意向等级与价值' }
          ],
          values: [
            { title: '销售转化率大幅提升', desc: '智能外呼转化率较传统人工大幅提升，订单量显著增长' },
            { title: '人力成本有效优化', desc: '缩小人工销售规模，降低人工成本占比，实现降本增效' }
          ]
        },
        {
          title: 'AI私域流量运营与精准客户激活',
          coreAbilities: [
            { title: '智能分层精准触达', desc: '基于意向评分模型分层，制定差异化触达策略与话术' },
            { title: '购买周期智能提醒', desc: '根据购买周期、使用习惯推送复购提醒与优惠' }
          ],
          values: [
            { title: '复购率显著提升', desc: '智能复购提醒使客户复购率有效增长' },
            { title: '私域转化效率倍增', desc: '私域流量转化效率提升，社群活跃度改善' }
          ]
        },
        {
          title: 'AI售后回访与智能客户关怀',
          coreAbilities: [
            { title: '智能满意度回访', desc: '订单完成后自动进行满意度调查与反馈收集' },
            { title: '问题智能识别转接', desc: '通过语音分析自动识别投诉，及时转接人工' }
          ],
          values: [
            { title: '客户满意度提升', desc: '售后回访覆盖率100%，问题及时解决，满意度显著提升' },
            { title: '投诉处理效率倍增', desc: '问题自动识别分类，投诉处理效率大幅提升' }
          ]
        }
      ]
    },
    government: {
      title: '政务',
      bannerTitle: ['AI语音赋能智慧政务服务', '打造咨询-宣传-调研多场景解决方案'],
      sectionTitle: 'AI语音赋能政务服务核心场景，提升便民服务效能',
      painPoints: [
        { title: '服务资源紧张', desc: '受工作时段、人力限制导致响应不及时，服务效率遇瓶颈' },
        { title: '数据整合困难', desc: '各部门业务系统独立，数据共享不畅，缺少有效数据支撑' },
        { title: '信息触达困难', desc: '政策宣传、应急通知等重要信息难以快速触达群众' },
        { title: '民意收集困难', desc: '传统民意调查成本高、周期长、样本少，了解群众诉求难' }
      ],
      solutions: [
        {
          title: 'AI政务服务智能咨询与多轮对话',
          coreAbilities: [
            { title: '政务知识库深度集成', desc: '整合政策法规、办事流程构建统一政务服务知识库' },
            { title: '多轮对话理解与转接机制', desc: '准确理解群众办事需求，提供精准解答，复杂问题自动转接人工' }
          ],
          values: [
            { title: '数据共享促进', desc: '推动各部门数据共享，打破信息孤岛，推动政务服务一体化' },
            { title: '7×24小时无间断服务', desc: '减少服务人员压力，服务效率大幅提升，群众满意度显著提高' }
          ]
        },
        {
          title: 'AI政策宣传与应急通知触达',
          coreAbilities: [
            { title: '百万级批量触达', desc: '支持百万级群众批量触达，确保重要信息及时传达' },
            { title: '精准人群多维筛选', desc: '基于地域、年龄、职业等维度实现精准推送' }
          ],
          values: [
            { title: '信息覆盖率显著提升', desc: '政策宣传及应急信息通知覆盖无死角' },
            { title: '传播成本大幅降低', desc: '相比传统方式成本极大降低，效率显著提升' }
          ]
        },
        {
          title: 'AI民意调查与实时舆情数据分析',
          coreAbilities: [
            { title: '智能问卷定制生成', desc: '基于调查目标定制问卷，支持开放式与选择题' },
            { title: '实时数据分析报告', desc: '调查数据实时分析，自动生成趋势报告与热点识别' }
          ],
          values: [
            { title: '调查效率飞跃提升', desc: '数周调查缩短至数天，效率提升几十倍' },
            { title: '样本规模显著扩大', desc: '样本量从千级提升至百万级，数据代表性增强' }
          ]
        }
      ],
      hero: {
        tag: 'AI政务咨询平台',
        titleLine1: '专为政务部门打造的',
        titleLine2: '全天候智能热线解决方案',
        descLine1: '助力政企单位实现数字化转型构建智能、便捷、',
        descLine2: '高效、安全的服务平台'
      },
      demand: {
        sectionTitle: '政企单位核心需求',
        items: [
          { title: '提升服务效率和满意度', desc: '业务查询、办理量日益增长，且重复性较高，急需数字化产品提高人效' },
          { title: '打通线上线下服务', desc: '减轻政府部门线下服务压力，推动群众自助在线上解决常见问题' },
          { title: '确保产品和数据安全', desc: '产品合规性及安全保障，能针对单位业务流程定制私有化部署方案' },
          { title: '降低人力服务成本', desc: '自建客服团队成本高昂，管理实施难度大，更需要一体化的服务解决方案' }
        ]
      },
      solve: {
        title: '顺势AI政务服务智能解决方案'
      },
      caseStudy: {
        badgeLine1: '北京市',
        badgeLine2: '东城区',
        street: '永外街道',
        streetEn: 'Yong Wai Sub‑District',
        tag: 'AI政务咨询平台',
        title: '已在北京市东城区永外街道成功应用',
        quote: '"AI系统部署后，群众夜间咨询得到及时响应，高频问题由AI统一解答，减轻了窗口压力，也让我们能更专注于复杂个案的处理。"——项目负责人'
      },
      feature: {
        consult: '立即咨询',
        tryFree: '免费体验',
        rows: [
          {
            titleLine1: '轻松创建知识库',
            titleLine2: '告别繁琐知识培训',
            items: [
              '知识库覆盖 95% 的高频咨询类别',
              '涵盖自采暖补贴、社保缴费、养老保险、低保政策等9大业务分工，街道办服务场景全覆盖'
            ]
          },
          {
            titleLine1: '智能服务热线',
            titleLine2: '大幅提升服务效率和满意度',
            items: [
              '7*24h 智能电话客服',
              '多轮对话与理解，意图识别',
              '多并发进线，群众咨询无等待'
            ]
          },
          {
            titleLine1: '智能数据分析与业务闭环处理',
            subTitle: '减轻政务部门线下服务压力',
            items: [
              '通话录音自动转写，智能填写工单',
              '自动汇聚分析所有咨询数据，生成分析报告',
              '减少人工坐席参与度，释放高价值人力'
            ]
          }
        ]
      },
      scene: {
        title: '顺势AI，政企服务场景全覆盖',
        items: [
          { title: '政策咨询', desc: '办事流程及时解答，政策解读精准到位' },
          { title: '进度查询', desc: '审批状态智能查询，证件结果实时告知' },
          { title: '投诉受理', desc: '投诉登记全程留痕，情绪安抚及时响应' },
          { title: '预约管理', desc: '办事挂号一键预约，服务排期灵活改约' },
          { title: '热线接听', desc: '群众热线智能分流，夜间应急随时响应' },
          { title: '信息登记', desc: '居民信息便捷录入，需求反馈自动汇总' }
        ]
      }
    },
    homeDecoration: {
      title: '家装',
      bannerTitle: ['AI语音赋能家装智能营销', '打通获客-咨询-转介绍全业务链条'],
      sectionTitle: 'AI语音赋能家装业务三大核心场景，构建数字化营销闭环',
      painPoints: [
        { title: '获客成本高昂', desc: '传统模式营销成本高、效果差，获客难度大' },
        { title: '销售效率低下', desc: '人工外呼量有限，培训周期长，团队稳定性差' },
        { title: '服务响应不及时', desc: '客户咨询、量房、售后问题等需求响应慢' },
        { title: '生命周期管理难', desc: '从意向到签约再到老客户推荐，缺乏有效管理' }
      ],
      solutions: [
        {
          title: 'AI智能获客与精准线索筛选',
          coreAbilities: [
            { title: '高峰需求弹性应对', desc: '单日处理能力无上限，应对楼盘交房、装修旺季等高峰需求' },
            { title: '多维度意向精准评分', desc: '基于装修、预算、决策、户型等维度实现精准分级' }
          ],
          values: [
            { title: '获客成本大幅降低', desc: '减少传统广告投放，单个线索成本降低50%以上' },
            { title: '线索质量显著提升', desc: '高意向客户筛选准确率提升，销售跟进转化率提高' }
          ]
        },
        {
          title: 'AI家装咨询与专业售后服务',
          coreAbilities: [
            { title: '家装知识库专业集成', desc: '整合流程、材料、风格、报价等专业内容，构建完整知识体系' },
            { title: '多轮对话需求分析', desc: '通过多轮对话精准分析客户需求（风格偏好、功能需求、预算等）' }
          ],
          values: [
            { title: '咨询响应极速提升', desc: '响应时间从小时级缩短至分钟级，客户满意度提升' },
            { title: '人力成本有效优化', desc: '减少客服人员配置，优化人力资源使用效率' }
          ]
        },
        {
          title: 'AI老客户维护与转介绍激活',
          coreAbilities: [
            { title: '客户生命周期全景管理', desc: '整合装修档案、服务记录、反馈，构建完整生命周期视图' },
            { title: '回访与转介绍机制传达', desc: '智能回访收集真实反馈，识别优质客户，推送转介绍奖励政策' }
          ],
          values: [
            { title: '客户忠诚度显著提升', desc: '定期关怀增强客户粘性，完整客户档案，为精准营销提供数据支撑' },
            { title: '转介绍率稳步增长', desc: '转介绍营销使新客户来源中老客户推荐占比稳步提升' }
          ]
        }
      ]
    },
    law: {
      title: '法律',
      hero: {
        tag: '外呼型AI语音系统',
        titleLine1: '法律咨询全周期',
        titleLine2: '案源运营与客户维系解决方案',
        desc: '助力律师事务性沟通工作量大幅减少，案源有效转化率显著提升'
      },
      demand: {
        sectionTitle: '当沟通仍以人工为主，效率与专业难以兼顾',
        items: [
          { title: '手动完成外呼任务，运营成本高', desc: '薪资+社保+绩效等人工成本高昂，人员流失 需承担解聘+再招聘+培训等隐性成本' },
          { title: '手动外呼效率低，产能有上限', desc: '受生理限制无法实现高强度的案源线索触达 并且业务淡旺季无法弹性调整坐席' },
          { title: '手动统计数据有误差，影响决策', desc: '依赖手动录入，案源关键信息容易漏记、错记 全链路数据缺乏系统管理，决策全凭经验' },
          { title: '合规风险高、服务体验差', desc: '不同律师专业水平参差不齐，话术易违规 且律师沟通环节耗时，无法聚焦高价值的案件分析' }
        ]
      },
      solution: {
        sectionTitle: '顺势AI，法律咨询场景解决方案',
        cards: [
          { title: '律所专属AI律师助理', desc: '深度融合法律术语与业务逻辑，拒绝通用模型泛化回答，确保前端咨询的专业度与合规性' },
          { title: '核心架构', desc: '涵盖高并发智能外呼、多轮对话、全量通话解析与可视化管控，实现从线索清洗到意向筛选的全流程自动化' }
        ]
      },
      chatDemo: {
        tag1: '专业话术库',
        tag2: '多轮复杂对话',
        tag3: '客户意图识别',
        tag4: '场景自动跳转',
        msg1: '我这边是北京律所，我们有专业的律师团队，擅长处理各类案件，请问您有法律相关的问题要咨询吗？',
        msg2: '有啊，你在哪里啊？',
        msg3: '我们在朝阳，海淀，东西城以及郊区有多家分所。',
        msg4: '您可以大概讲讲遇到什么情况吗？'
      },
      feature: {
        sectionTitle: '不是传统AI，而是你的案源增长助理',
        consult: '立即咨询',
        module1: {
          titleLine1: '一键外呼批量触达',
          titleLine2: '快速筛选有效案源',
          items: [
            '支持Excel/CSV格式批量上传，一键生成外呼任务',
            '系统支持高并发，单日外呼量可达数万通',
            '支持匹配接听高峰期，避开无效拨打时段'
          ],
          caption: '媲美专业律师助理的智能接待'
        },
        module2: {
          titleLine1: '通话数据全量分析',
          titleLine2: '并生成分析报告与多维看板',
          items: [
            '全程录音与智能转写',
            '无效咨询智能拦截，线索量化打分',
            '客户画像分析报告自动生成',
            '多维度数据报表'
          ]
        }
      },
      deploy: {
        sectionTitle: '一周上线，无缝衔接您的业务体系',
        items: [
          { title: '标准化极速交付', desc: '从需求确认到正式上线仅需一周，业务价值快速落地' },
          { title: 'SaaS版即开即用', desc: '有网络开机即用，极大降低律所IT基础设施成本与维护压力' },
          { title: '现有系统无缝融合', desc: '深度适配律所主流案件管理及财务系统，业务流程打通' }
        ]
      },
      scene: {
        sectionTitle: '哪些场景适合用 顺势AI 替代人工',
        items: [
          { title: '多渠道案源线索的及时响应与快速筛选', desc: '律所线索来源分散，渠道质量参差不齐。传统人工外逐一筛选效率极低，黄金响应时间（15分钟）内无法触达，高价值客户流失严重，广告预算浪费。' },
          { title: '案源分类与数据分析汇总', desc: '大量客户通话信息依赖律师手动Excel记录，关键信息漏记、意向等级主观修饰导致数据源头失真。管理层无法看清各渠道转化率，决策缺乏数据支撑。' },
          { title: '结案后的满意度回访维护', desc: '结案后缺乏系统化的满意度调查机制，人工跟进效率低，错失服务优化机会。' },
          { title: '7X24小时承接法律服务进线咨询', desc: '传统依靠律师接听咨询，受生理限制及夜间、周末工作时长限制容易错失高质量案源。' }
        ]
      }
    }
  },
  product: {
    common: {
      tryNow: '立即体验',
      featuresTitle: '核心能力'
    },
    outbound: {
      title: '外呼型AI语音系统',
      bannerTitle: ['AI语音智能外呼', '主动触达每一通潜在客户'],
      intro: '面向营销、回访、邀约、通知等主动触达场景，以真人级AI外呼替代人工坐席，实现海量并发、精准意向识别与全流程自动化。',
      sectionTitle: '外呼型AI语音系统核心能力',
      features: [
        { title: '超高并发外呼', desc: '单日处理能力无上限，轻松应对海量线索触达与业务波峰。' },
        { title: '真人级自然对话', desc: '声音高度拟人，支持复杂多轮交互，客户几乎察觉不到是AI。' },
        { title: '实时意向评分', desc: '通话语义实时分析，自动输出意向评分与需求标签，精准筛选线索。' },
        { title: '全流程自动化', desc: '从数据导入、自动外呼、表单填写到数据汇总，全链路自动化闭环。' },
        { title: '合规智能质检', desc: '内置违规识别与拦截，自动过滤敏感词，规避合规风险。' },
        { title: '弹性按需部署', desc: '淡旺季灵活增减并发，即开即用，无需长期养人。' }
      ]
    },
    inbound: {
      title: '呼入型AI语音系统',
      bannerTitle: ['AI语音智能呼入', '7×24小时贴心接待每一通来电'],
      intro: '面向咨询、客服、售后、业务办理等呼入场景，以真人级AI智能应答替代人工坐席，实现全天候接待、秒级响应与精准转接。',
      sectionTitle: '呼入型AI语音系统核心能力',
      features: [
        { title: '7×24小时在线', desc: '全天候无人值守接待，非工作时间、节假日同样即时响应。' },
        { title: '多轮对话理解', desc: '精准理解来电意图，灵活完成多轮交互，复杂问题自动转接人工。' },
        { title: '知识库精准应答', desc: '回答严格限定于预设知识库，杜绝模型幻觉，确保准确无误。' },
        { title: '情绪与方言感知', desc: '实时感知客户情绪与方言，自动匹配流程并切换安抚话术。' },
        { title: '智能转接协同', desc: '标准问题AI即时解决，复杂问题无缝转接人工，提升协同效率。' },
        { title: '多维数据统计', desc: '每通来电结构化记录，自动生成字段采集与意图摘要。' }
      ],
    }
  },
  productOutbound: {
    hero: {
      tag: '外呼型AI语音系统',
      titleLine1: '让每一通外呼电话',
      titleLine2: '都更接近成交',
      desc: '如同一位不知疲倦的在线的电销经理，灵活交互，自主采集汇总信息，自动生成用户画像，并线索打分',
      cta: '立即体验'
    },
    stats: [
      '综合成本降低',
      '外呼效率提升',
      '全量通话质检',
      '标签合规话术'
    ],
    statsSuffix: [
      '%',
      '倍+',
      '%',
      '%'
    ],
    pain: {
      title: '用顺势AI，帮你解决',
      items: [
        '人工拨打效率低，转化白白流失',
        '业务高峰与低谷，坐席配置弹性差',
        '人员流动大，培训与招聘成本高',
        '通话数据分散，想要复盘无从下手',
        '人工培训周期长，话术质量参差不齐',
        '手动清单易出错，客户信息断层'
      ]
    },
    feature: {
      title: '用顺势 AI，聚焦电销场景客资转化',
      subtitleLine1: '多渠道线索汇聚、批量外呼触达',
      subtitleLine2: 'AI驱动精准营销，高效转化',
      items: [
        '一键创建任务，批量导入数据，万路并发，单日百万通高效触达',
        'AI自动开展多轮对话，支持打断与意图跳转',
        '自主完成合规客资采集、产品介绍、邀约确认',
        'AI自动识别高意向客户，自主量化打分，助力销售精准跟进',
        '根据通话内容，智能生成客户画像与需求标签',
        '通话结束自动归档录音+文字稿+关键数据，全量质检合规可溯源',
        '多维度数据看板实时更新，通话结果反馈营销策略与话术优化'
      ],
      cta: '立即咨询'
    },
    cost: {
      titlePrefix: '用顺势AI，比人工电销',
      titleHighlight: '每月省90%',
      commission: '提成绩效 ¥1000',
      office: '场地管理 ¥800',
      recruit: '招聘培训 ¥800',
      social: '社保公积金 ¥2000',
      salary: '薪资 ¥3000-5000',
      computeFee: '算力费',
      aiFee: 'AI费用',
      manualTitle: '人工电销',
      aiTitle: '顺势AI',
      desc: '成本计算估值：AI费用+算力费≈人工成本的十分之一（电话费可选未计）'
    },
    efficiency: {
      titlePrefix: '用顺势AI，比手动拨号',
      titleHighlight: '效率提高40倍+',
      manualLabel: '手动拨打',
      manualValue: '100-200通/天',
      manualSuffix: 'X 坐席人数',
      aiLabel: 'AI外呼',
      aiValue: '8000-10000通/天',
      aiSuffix: 'X AI坐席小组数',
      tip1: '当1个AI坐席小组=10个并发时，单坐席小组每日可外呼8000-10000通',
      tip2: '线路允许的情况下，多个AI坐席小组同时外呼可实现单日上百万通的外呼量，极大提高工作效率'
    },
    check: {
      titlePrefix: '用顺势AI，全量录音',
      titleHighlight: '质检100%覆盖',
      manual: '人工抽检',
      manualValue: '漏检率＞95%',
      ai: 'AI全量质检',
      aiValue: '覆盖率100%'
    },
    scene: {
      title: '顺势AI，外呼营销全场景覆盖',
      items: [
        { title: '活动通知', desc: '批量触达潜在客户' },
        { title: '服务回访', desc: '打通售后服务链' },
        { title: '产品介绍', desc: '意向精准定位' },
        { title: '问卷调查', desc: '话术模板快速生成' },
        { title: '到期提醒', desc: '主动提醒+互动解答' },
        { title: '会员关怀', desc: '沉淀客户唤醒' },
        { title: '信息确认', desc: '自动填写表单' },
        { title: '活动邀约', desc: '一键外呼筛选' }
      ]
    }
  },
  productInbound: {
    hero: {
      tag: '呼入型AI语音系统',
      titleLine1: '让每一次进线咨询',
      titleLine2: '都得到及时响应',
      descLine1: '如同一名24小时在线的客服主管，精准识别意图，自动分流',
      descLine2: '复杂问题转人工，重复咨询即问即答',
      cta: '立即体验'
    },
    stats: [
      '综合成本降低',
      '常规咨询自主承接',
      '不间断服务能力',
      '秒级响应零等待'
    ],
    pain: {
      title: '用顺势AI，帮你解决',
      items: [
        '客户来电响应慢，等待时间长影响体验',
        '咨询高峰转接不过来，低谷人力闲置浪费',
        '客服培训周期长，服务质量参差不齐',
        '夜间/节假日无人接听，服务存在盲区',
        '通话数据难统计，重要决策全凭经验',
        '重复问题占用人力，高价值客户被忽略'
      ]
    },
    feature: {
      title: '用顺势AI，聚焦进线咨询场景服务提效',
      subtitleLine1: '用户来电统一承接、智能分流应答',
      subtitleLine2: 'AI驱动高效服务，数据智能汇总',
      items: [
        '用户来电AI秒级接听，7×24h在线',
        '基于知识库精准应答，杜绝错答，产品/政策解读规范',
        'AI自动识别客户意图，复杂问题无缝转人工并同步上下文',
        '通话结束自动建单、补全字段，投诉建议即时流转责任部门',
        '根据通话内容，智能生成客户画像与需求标签',
        '通话结束自动归档录音+文字稿+关键数据，全量质检可溯源',
        '服务数据分类汇总，智能生成分析报告',
        '多维度数据看板及时更新，咨询热点与坐席效能一目了然'
      ],
      cta: '立即咨询'
    },
    cost: {
      titlePrefix: '用顺势AI，淡旺季',
      titleHighlight: '弹性成本管控',
      note: '注：图表仅展示AI与人工成本随业务淡旺季波动对比，为示意图。具体成本结构以实际使用为准。'
    },
    efficiency: {
      title: '用顺势AI，覆盖夜间及周末服务时段盲区',
      dutyLabel: '值守时长',
      manualTitle: '人工坐席',
      manualTag: '↗难覆盖',
      manualDesc: '夜间、周末、节假日无人值守',
      weekday: '工作日',
      eightHours: '8小时制',
      aiTitle: '顺势AI',
      aiTag: '↗全天候',
      aiDesc: '无节假日、无周末、无夜间休息',
      allDay: '7X24小时'
    },
    check: {
      titlePrefix: '用顺势AI，助力',
      titleHighlight: '团队数字化管理'
    },
    scene: {
      title: '顺势AI，进线咨询全场景覆盖',
      items: [
        { title: '客服热线', desc: '高效解答客户疑问' },
        { title: '投诉建议', desc: '全量录音留痕' },
        { title: '维修报修', desc: '自动记录，工单流转' },
        { title: '产品咨询', desc: '需求个性化推荐' },
        { title: '业务办理', desc: '业务流程指南' },
        { title: '售前售后', desc: '规则判定，退换流程' },
        { title: '自助查询', desc: '自动匹配知识库' },
        { title: '预约服务', desc: '自动提取信息' }
      ]
    },
    pyramid: {
      decisionLayer: '决策层',
      decisionTip: '精准决策依据',
      smartExtract: '智能提炼',
      analysisLayer: '分析层',
      analysisTip: '高频诉求识别 · 趋势变化研判',
      autoCollect: '自动采集',
      dataLayer: '数据层',
      dataTip: '海量咨询数据结构化管理'
    }
  },
  footer: {
    company: '北京顺势众捷科技有限公司',
    phone: '联系方式：18755615081',
    address: '联系地址：北京市海淀区上地亿城国际中心5层',
    productCenter: '产品中心',
    productOutbound: '外呼型AI语音系统',
    productInbound: '呼入型AI语音系统',
    scenarioTitle: '应用场景',
    scenarioGovernment: '政务领域',
    scenarioLegal: '法律行业',
    scenarioCar: '汽车行业',
    wechatWork: '企业微信',
    wechatOfficial: '公众号',
    copyright: '© 2026 顺势众捷 版权所有 | 京ICP备2026030486号'
  },
  popup: {
    title: '申请试用',
    subtitle: '提交信息，我们将尽快与您联系',
    company: '公司名称',
    name: '您的姓名',
    phone: '手机号码',
    city: '城市',
    code: '验证码',
    remark: '需求描述',
    companyPlaceholder: '请输入公司名称',
    namePlaceholder: '请输入您的姓名',
    phonePlaceholder: '请输入手机号码',
    cityPlaceholder: '请输入城市',
    codePlaceholder: '请输入验证码',
    remarkPlaceholder: '请简单描述您的需求',
    getCode: '获取验证码',
    retry: '{n}秒后重试',
    submit: '提交申请',
    msgInvalidPhone: '请输入正确的手机号码',
    msgCodeSent: '验证码已发送，请注意查收',
    msgCodeFail: '验证码发送失败，请稍后重试',
    msgCodeError: '发送验证码失败，请检查网络或手机号',
    msgIncomplete: '请填写完整的必填项',
    msgSubmitSuccess: '提交成功！我们将尽快与您联系',
    msgSubmitFail: '提交失败，请稍后重试',
    msgSubmitError: '提交申请失败，请检查网络或稍后再试'
  },
  apply: {
    title: '填写你的团队信息',
    subtitle: '提交信息 10 分钟内专属顾问一对一对接',
    company: '企业名称',
    companyPlaceholder: '请输入企业名称',
    city: '省份城市',
    cityPlaceholder: '请输入省份城市',
    phone: '联系方式',
    phonePlaceholder: '请输入联系方式',
    code: '验证码',
    codePlaceholder: '请输入验证码',
    remarkPlaceholder: '请输入您的留言',
    getCode: '获取验证码',
    retry: '{n}秒后重试',
    submit: '立即申请',
    contactText: '或致电我们，让我们为您服务',
    msgInvalidPhone: '请输入正确的手机号码',
    msgCodeSent: '验证码已发送，请注意查收',
    msgCodeFail: '验证码发送失败，请稍后重试',
    msgCodeError: '发送验证码失败，请检查网络或手机号',
    msgIncomplete: '请填写完整的必填项',
    msgSubmitSuccess: '提交成功！我们将尽快与您联系',
    msgSubmitFail: '提交失败，请稍后重试',
    msgSubmitError: '提交申请失败，请检查网络或稍后再试'
  },
  meta: {
    home: '顺势众捷 - AI智能服务新引擎',
    advantage: '核心优势 - 顺势众捷',
    solution: '解决方案 - 顺势众捷',
    productOutbound: '外呼型AI语音系统 - 顺势众捷',
    productInbound: '呼入型AI语音系统 - 顺势众捷',
    faq: '常见问题 - 顺势众捷',
    about: '关于我们 - 顺势众捷',
    description: '北京顺势众捷科技有限公司，专注为企业提供下一代AI语音模型应用解决方案，覆盖汽车、政务、保险、教育、金融、电商、家装等场景，助力企业实现智能化客户运营与高效外呼。',
    keywords: 'AI语音外呼,AI智能语音,智能外呼系统,钟声2.0,顺势众捷'
  },
  home: {
    tryNow: '立即体验',
    heroTitle: '顺势AI智能语音系统',
    heroSubtitle: '全场景精准营销与智能服务方案',
    heroDesc: '无论是呼入咨询还是外呼营销，我们都可以帮您提供高效的 AI 语音智能解决方案',
    heroStatsPrefix: '日均处理',
    heroStatsSuffix: ' 通话',
    listenFirst: '先听效果',
    talkCooperation: '再谈合作',
    userTitlePrefix: '他们都在用',
    userTitleBrand: '顺势 AI',
    userTitleSuffix: '连接用户',
    userImageAlt: '使用用户',
    recordLaw: '法律行业案例',
    recordCar: '汽车行业案例',
    caseTip: '因客户合规要求，暂不便展示品牌标识，实际合作内容与数据均为真实案例。',
    cases: [
      { name: '北京多家法律行业单位', desc: '2026年7月，外呼型AI语音系统在法律行业规模化复制应用。' },
      { name: '北京市东城区永外街道办', desc: '2026年7月8日，AI政务咨询平台成功上线，切实打通便民服务的“最后一米”。' },
      { name: '国内汽车大型交易平台', desc: '2025年6月，外呼型AI语音系统在汽车营销领域完成客户验证。' },
      { name: '保险行业客户', desc: '系统在保险行业完成规模化落地，AI外呼用于客户回访与线索筛选。' }
    ],
    overview: {
      title: '用顺势 AI，让企业降本增效',
      desc: '呼出主动触客  •  呼入精准响应',
      outbound: {
        title: '外呼型AI语音系统',
        subtitle: '低成本批量触客、智能筛选锁定 高意向客户，适配全行业营销拓客场景',
        items: ['综合成本直降90%+', '作业效率提升40倍+', '单日外呼量百万通+']
      },
      inbound: {
        title: '呼入型AI语音系统',
        subtitle: '全天候承接进线咨询、智能分流标准化答疑，平稳应对业务进线高峰期',
        items: ['7X24小时不间断服务', '覆盖95%咨询类别', '弹性扩容，灵活并发']
      },
      government: {
        title: 'AI政务咨询平台',
        subtitle: '全天候政策智能解读、自动分办导办，满足跨部门协同，实现群众办事 “一次办好”',
        items: ['覆盖夜间及周末服务盲区', '私有化部署数据物理隔离', '工单、数据报表自动生成']
      },
      detail: '了解详情'
    },
    serviceUpgrade: {
      title: '用顺势 AI，让服务体验升级',
      desc: '简单、易用、强大，不断进化的 AI 能力',
      naturalTitle: '让 AI 沟通更加自然，接近真人',
      naturalItems: [
        { title: '真人音色克隆', desc: '可生成与真人几乎无差别的声音，打造专属声音形象' },
        { title: '实时语音合成', desc: '低延迟语音生成，对话场景中与真人客服一样自然流畅' },
        { title: '多种方言识别', desc: '支持几十种方言智能识别，满足全行业多场景业务需要' },
        { title: '语音识别准确', desc: '智能识别嘈杂语言环境、微弱及模糊不清语言自动追问' },
        { title: '交互媲美真人', desc: '支持客户打断、转移话题、追问、可完成多轮复杂业务对话' }
      ],
      quickDeploy: {
        title: '极速建模上线，无需长期培训',
        desc1: '行业预制话术，需求确认后可快速生成模型',
        desc2: '一周内对接上线，零长周期培训',
        node1: '需求对接',
        node2: '系统开发',
        node3: '测评上线',
        node4: '系统运维',
        flywheel: {
          intake: '业务接入',
          test: '测评上线',
          strategy: '策略迭代',
          service: '实战服务'
        }
      },
      deploy: {
        title: 'SaaS版 / 私有化双部署模式',
        desc1: 'SaaS版即开即用',
        desc2: '涉密、政务场景支持本地独立部署，兼顾灵活与数据安全'
      },
      digitalHuman: {
        title: '数字人可视化联动，体验升级',
        desc1: '前端可配套数字人形象',
        desc2: '语音 + 视觉双向交互，提升客户沟通沉浸感'
      },
      consult: '立即咨询'
    },
    workflow: {
      title: '用顺势AI，打造线索触达 - 数据沉淀业务闭环',
      desc: '一套 AI 语音系统完成线索触达、客户服务、数据复盘全流程',
      steps: [
        { title: '客户连接', desc1: '批量导入数据', desc2: '或进线接入' },
        { title: '智能沟通', desc1: '多轮自然对话', desc2: '意图精准识别' },
        { title: '意向筛选', desc1: '自动评分分级', desc2: '高潜客户标记' },
        { title: '线索跟进', desc1: '工单自动创建', desc2: '无缝转接人工' },
        { title: '数据优化', desc1: '全量数据沉淀', desc2: '通话分析报告' }
      ]
    },
    whyChoose: {
      title: '为什么选择顺势AI',
      desc: '专注垂直场景模型专项训练，让AI真正懂你的业务',
      items: [
        { title: '垂直场景深耕，模型适配性更强', desc: '针对政务、汽车、律所等细分赛道专项训练，对话贴合行业真实业务流程' },
        { title: '政企双重落地验证，成熟可复用', desc: '政务街道、商业垂直平台批量落地项目，真实业务场景跑通，方案成熟稳定' },
        { title: '北大团队自研算法，性能稳，迭代快', desc: '来自顶尖学府北大、人大、财大的算法团队自研语言算法，性能稳，迭代快' },
        { title: '12年+技术经验，专业运营服务能力', desc: '核心技术团队拥有丰富的模型落地经验，可以提供7X24小时的专业服务' }
      ]
    },
    application: {
      title: '携手全行业通话场景，与AI共进化',
      desc: '可配置不同行业知识库，专属模型训练，专属客户一对一服务',
      detail: '查看详情'
    },
    industries: {
      car: '汽车行业',
      finance: '金融行业',
      commerce: '电商行业',
      education: '教育行业',
      insurance: '保险行业',
      government: '政府行业',
      homeDecoration: '家装行业',
      law: '法律行业'
    }
  },
  advantage: {
    bannerLine1: '以AI技术为核心打造',
    bannerHighlight1: '行业领先的',
    bannerHighlight2: '智能语音解决方案',
    techTitle: '创新驱动的技术体系',
    techDesc: '自主研发核心技术，持续创新迭代',
    coreTitle: '三大核心优势引擎',
    coreDesc: '降低成本、提高效率、提升服务质量',
    items: [
      {
        title: '降低成本',
        subtitle: '用AI替代人工坐席，免招聘、免培训、时段灵活',
        details: [
          { title: '真人级AI对话，替代人工坐席', text: '95%用户难辨真伪，可替代客服、回访、邀约等重复性人力岗位，大幅缩减人力成本开支。' },
          { title: '即开即用，按需弹性部署', text: '根据业务淡旺季增减并发线路，旺季随时加，淡季零闲置，无需为短期需求长期养人。免去招聘、培训、流失再招聘的循环，管理成本趋近于零。' },
          { title: '服务时段更加灵活可控', text: '法规条件允许的时段内支持自定义时段全量响应，无排班、无加班费，运营成本极大降低。' }
        ]
      },
      {
        title: '提高效率',
        subtitle: '从数据到结果全流程自动化，海量并发极速触达',
        details: [
          { title: '超高并发，单日百万级触达', text: '在线路及时间段允许的情况下，单日可实现上百万通外呼量，传统人工无法比拟，业务批量处理效率飙升。' },
          { title: '外呼全流程实现自动化闭环', text: '从数据导入 → 自动外呼 → 通话中实时意向评分 → 自动填写表单 → 财务汇总→ 智能分析与建议，全链路自动化。' },
          { title: '线索实时意向打分，精准筛选', text: '基于通话语义分析、字段采集等多个维度，输出线索意向分值，高分线索持续跟进，低分线索自动培育，转化效率大幅提升。' }
        ]
      },
      {
        title: '提升服务质量',
        subtitle: 'AI精准应答，释放人力专注高价值服务',
        details: [
          { title: 'AI搞定高频、标准化咨询', text: '音色自然，灵活交互多轮对话，基于行业知识库自动回复常见问题（业务咨询、产品讲解等），秒级响应。' },
          { title: '释放人力专注其他深度服务', text: '员工从重复问答中解放出来，集中精力处理复杂事物、情感维系、个性方案设计，整体服务品质和客户感知显著提升。' },
          { title: '数据驱动持续优化服务质量', text: '每通对话都被完整记录与分析，模型不断优化，越用越懂业务和客户，服务水准稳步上升。' }
        ]
      }
    ],
    tech: [
      { title: '自研AI语音应用模型', desc: '基于大模型的自研AI语音应用模型，识别准确率更高' },
      { title: '秒级响应', desc: '分布式架构设计，确保高并发场景下的秒级响应' },
      { title: '多语言支持', desc: '支持中英文及多种方言，满足全球化业务需求' },
      { title: '灵活部署', desc: '支持大模型本地化部署可根据需求灵活配置资源' }
    ]
  },
  faq: {
    bannerTitle: '钟声2.0',
    bannerSub: '常见问答',
    bannerDesc: '覆盖产品体验、技术实现、合作渠道、功能细节等核心问题，快速找到您所需的答案。',
    product: {
      title: '产品概述',
      q: '钟声2.0是什么？',
      a: '钟声2.0是北京顺势众捷科技有限公司为响应企业智能化服务升级需求，聚焦AI语音外呼与咨询场景，针对当前企业面临的客户咨询量激增、人力成本高企、夜间及非工作时间服务空白，以及外呼体验差、效率低、意向筛选难等现状，面向广大企业与政务部门而开发的一款AI语音交互解决方案。它专为营销中心、客服中心、基层办事窗口等场景研发，精准服务销售跟进与咨询需求，助力每一次通话都变成可量化的用户洞察，让服务更高效、更亲切、更智能。',
      coreTitle: '核心优势：',
      advantages: [
        '能够应对复杂对话场景，支持多轮交互，精准理解并记录用户的核心诉求及关键字段。',
        '回答严格限定于预设知识库范围内，杜绝模型幻觉，确保绝不乱答、错答。',
        '声音高度拟人，响应零延迟，带来媲美真人的自然对话体验。',
        '在同等音质与性能水平的语音模型中，提供最具竞争力的价格。'
      ]
    },
    launch: {
      title: '上线时间',
      q1: '上线需要多久？',
      intro: '我们提供灵活的上线方案：',
      items: [
        { tag: '即时开通', title: '标准版产品', desc: '开箱即用，无需等待' },
        { tag: '快速定制', title: '定制化配置', desc: '5-7天内完成定制化配置和上线' },
        { tag: '深度调优', title: '专业调优服务', desc: '针对特定行业场景，确保最佳效果' }
      ],
      q2: '一天能打多少通电话？',
      callNum: '百万通以上',
      callDescBefore: '单次外呼并发数高至',
      callDescAfter: '，支持弹性扩容，可根据业务需求及预算灵活增减并发数量。',
      tipBefore: '在线路及时间段允许的情况下，单日可实现',
      tipStrong: '上百万通',
      tipAfter: '的外呼量，极大提高业务效率。'
    },
    security: {
      title: '数据安全与合规',
      q: '数据安全怎么保障？',
      intro: '我们提供多级数据安全方案，确保客户数据安全：',
      items: [
        { title: '加密传输方案', desc: '支持端到端加密传输，确保通话数据在传输过程中的安全性' },
        { title: '保密协议保障', desc: '内部设有严格管理制度，并与客户签署保密协议，杜绝数据滥用' },
        { title: '用户自主管控数据', desc: '我方负责输出模型能力，用户数据做到不触碰、不留存并且可随时删除，数据全程由用户自主管控' },
        { title: '私有化部署', desc: '针对高安全要求客户，支持私有化部署方案' }
      ],
      note: '我们始终将数据安全放在首位，严格遵守相关法律法规和行业标准。'
    },
    effect: {
      title: '效果验证',
      q: 'AI外呼的效果如何评估？',
      intro: '我们通过成本、效率、服务质量和合规风险四大维度，构建完整的外呼效果评估体系：',
      headers: ['评估维度', '具体指标', '传统人工外呼', '其他AI模型', '钟声2.0'],
      rows: [
        { dimension: '成本维度', indicators: [
          { name: '人工成本', manual: '人员薪资及保险', other: '部分需定制费', ours: '0元（即开即用）' },
          { name: '招聘、培训、场地、运营成本', manual: '持续投入，人均数百上千', other: '部分需人工调优', ours: '0元（辅助调优）' },
          { name: '业务淡季成本', manual: '照常发薪', other: '闲置占资源', ours: '零闲置（按需付费）' }
        ] },
        { dimension: '效率维度', indicators: [
          { name: '单日（单坐席）触达量', manual: '200-300通', other: '500-2000通', ours: '百万通以上' },
          { name: '意向筛选与分配', manual: '手动筛选，耗时长', other: '意向识别准确率低，分配不及时', ours: '意向识别准确率高，实时分配' },
          { name: '数据录入效率与错误率', manual: '1-3分钟/条，手动填写，准确率低', other: '机械识别，准确率低', ours: '实时识别，自动纠错，自动填写，准确率高' }
        ] },
        { dimension: '服务质量维度', indicators: [
          { name: '对话自然度', manual: '依赖个人，波动大', other: '部分机械感或延迟', ours: '95%用户认为真人' },
          { name: '复杂对话能力', manual: '可处理多轮，但易疲劳', other: '多简单多轮，易跑题', ours: '支持复杂多轮，精准理解并记录' },
          { name: '回答准确性', manual: '易记错，标准不一', other: '存在模型幻觉', ours: '严格限定知识库，杜绝幻觉、乱答' },
          { name: '服务一致性', manual: '受情绪、熟练度影响', other: '相对稳定', ours: '高度稳定，始终最佳状态' },
          { name: '多维数据统计', manual: '手动少量标记', other: '基础报表', ours: '每通电话结构化表达：字段采集与意向评分，推送摘要' }
        ] },
        { dimension: '合规风险维度', indicators: [
          { name: '不合规风险与管理盲区', manual: '易遗漏关键授权与使用不合规技术，监管困难，存在信息泄露风险', other: '需配合人工质检或额外收费的质检模型使用', ours: '内置智能识别与拦截功能，自动过滤违规词汇，规避合规风险' }
        ] }
      ]
    },
    custom: {
      title: '场景定制',
      q: '能否支持定制化场景？',
      intro: '是的，我们支持深度定制化：',
      items: ['行业专属知识库', '定制化话术逻辑', '特殊场景适配', '系统集成需求']
    },
    cooperation: {
      title: '合作与商务政策',
      q1: '是否有试用体验？',
      intro1: '我们提供1V1专属行业顾问服务，支持0成本体验：',
      items1: ['免费试用', '专属顾问', '效果评估', '方案定制'],
      q2: '是否有渠道政策？',
      intro2: '我们欢迎各类合作伙伴：',
      items2: ['代理商政策', '技术合作伙伴', '行业解决方案伙伴', '战略合作伙伴'],
      note: '具体合作模式和分润方案由商务同事详细介绍，我们致力于打造合作共赢的生态体系。'
    },
    support: {
      title: '技术支持与售后服务',
      q1: '技术支持响应时间如何？',
      intro1: '我们提供多层次的技术支持体系：',
      items1: ['7×24小时在线支持', '专属技术顾问', '深度技术培训', '问题分级处理'],
      q2: '产品是否会持续更新升级？',
      intro2: '是的，我们持续投入研发：',
      items2: [
        { strong: '定期功能更新：', text: '定期发布功能优化和新增功能' },
        { strong: '技术升级保障：', text: '基于最新AI技术持续优化产品性能' },
        { strong: '客户需求响应：', text: '优质客户需求持续纳入开发计划' },
        { strong: '行业趋势跟进：', text: '紧跟行业发展趋势，保持产品竞争力' }
      ],
      note: '我们的团队来自北京大学、中国人民大学、中央财经大学等顶尖学府，在大语言模型、核心算法及软件开发等领域具备深厚积淀，确保产品始终处于技术前沿。'
    },
    title: '顺势AI智能语音系统',
    highlight: '常见问题',
    tabs: [
      '全部',
      '产品概述',
      '产品体验',
      '价格费用',
      '上线周期',
      '功能特性',
      '数据安全',
      '效果与接通率'
    ],
    items: [
      { cat: 1, question: '顺势AI智能语音系统是什么？', answer: '顺势AI智能语音系统是一套基于大模型基模实现的一款AI语音应用产品。它专注于外呼营销与呼入客服场景，提供全链路AI电话解决方案，旨在替代重复性电话劳动，有效应对客户咨询激增、人力成本高企、非工作时间服务空白，以及外呼效率低、意向筛选难等现实问题。' },
      { cat: 1, question: '该产品适用于哪些场景？', answer: '该产品专为营销中心、客服中心及服务热线等场景研发。其核心价值在于以极低的成本实现全天候、高质量、高效且无限复制的电话服务，不受时间、人力与情绪限制；同时将每一次通话转化为可量化的用户洞察，让服务更高效、更亲切、更智能。' },
      { cat: 2, question: '和传统的电话机器人有什么区别？', answer: '顺势AI不是播放录音的机器人。它基于大模型基模，能进行多轮复杂对话，听懂客户意图，支持打断，回答更灵活。能独立处理95%以上的常规业务。复杂或特殊问题会无缝转接人工坐席，并同步对话上下文，人工只需处理高价值部分。' },
      { cat: 2, question: '一天能打多少通电话？', answer: '外呼场景：单个AI坐席小组（10个并发）日最高外呼8000-10000通。如需更大规模，可增加AI坐席小组数，单日外呼量可达百万通。接听场景：按并发数收费，不限制通话总量。' },
      { cat: 3, question: '怎么收费？大概多少钱？', answer: '主要为AI坐席小组数（每个AI坐席小组10个并发）+ 算力，按月收费。一个AI坐席小组的月费（含算力）大约是人工坐席成本的1/10。无社保、招聘、场地等附加成本。支持根据业务淡旺季灵活增减坐席。（电话费可选未计）' },
      { cat: 3, question: '除了月费还有其他费用吗？', answer: '主要费用是AI坐席小组服务费与算力费，已包含系统使用和技术支持。电话线路费用企业可自行向运营商申请，我们可提供线路选型指南。' },
      { cat: 4, question: '从签约到上线要多久？', answer: '标准化产品最快1周即可上线使用。包含需求调研、话术配置、测试联调。如需深度定制，周期约为2-4周。' },
      { cat: 4, question: '上线流程是怎样的？', answer: '标准5步流程：\n1）需求调研；\n2）方案定制；\n3）系统部署与培训；\n4）小范围试运行优化；\n5）全面推广。全程有专人跟进。' },
      { cat: 5, question: 'AI的声音可以选吗？能定制吗？', answer: '提供多种标准音色（男女声均有）可选。也支持声音复刻服务，您可上传录音定制专属品牌音色。' },
      { cat: 5, question: '能对接我们自己的CRM系统吗？', answer: '可以。提供标准API接口，对接后实现：带客户信息外呼、通话结果与录音自动回写CRM、根据CRM数据自动触发外呼任务，形成数据闭环。' },
      { cat: 6, question: '通话数据安全吗？客户信息会泄露吗？', answer: '提供三级安全方案：\n1）签署保密协议；\n2）支持客户用自己的线路拨号，AI只负责接听；\n3）端到端金融级加密，数据可按约定留存或由企业自主下载管理。' },
      { cat: 6, question: '政务咨询版的数据如何保障安全？', answer: '政务咨询平台采用本地独立部署模式，所有数据存储在您指定的服务器内，与公网物理隔离，保障100%的数据主权与安全。' },
      { cat: 7, question: '外呼的接通率一般有多少？', answer: '接通率受线路质量、外呼时段、号码新鲜度、地区共同影响。使用运营商实名卡、在工作日9:30-12:00 & 14:00-18:00拨打新鲜号码，效果最佳，通常可达人工团队水平。' },
      { cat: 7, question: '如何保证通话效果和转化率？', answer: '效果取决于“话术质量”与“线索质量”。我们提供行业话术模板与优化服务，并建议您持续更新优质线索库。AI能稳定执行最佳话术，避免人工状态波动带来的效果损失。' }
    ]
  },
  about: {
    title: '关于',
    titleHighlight: '顺势众捷',
    intro: [
      '北京顺势众捷科技有限公司坐落于北京市海淀区AI创新腹地，是一家深耕AI语音赛道的科技型企业。公司以自研语音应用模型为核心，通过将顶尖人才的专业能力沉淀为标准化、可复用的AI模型，帮助客户将专业的电话服务能力部署到每一个通话节点。我们助力企业实现7×24小时永不占线的智能应答、精准线索筛选与全过程服务留痕，真正将“降本增效”落地到每一次通话。',
      '目前，业务已覆盖政务、金融、保险、汽车、教育、电商、家装、律所等多个领域，积累了丰富的垂直场景落地经验。'
    ],
    timelineTitle: '公司发展史',
    timeline: [
      { year: '2026年7月', desc: '外呼型AI语音系统在律所、保险等领域规模化复制启动' },
      { year: '2026年3月', desc: '呼入型AI语音系统在北京市东城区永外街道办投入使用' },
      { year: '2025年10月', desc: '呼入型AI语音系统上线，形成“呼入+呼出”产品闭环' },
      { year: '2025年6月', desc: '外呼型AI语音系统在汽车营销领域完成验证' },
      { year: '2025年4月', desc: '外呼型AI语音系统上线，实现商业化落地' },
      { year: '2024年2月', desc: '核心算法团队专注于自研语音应用模型开发' },
      { year: '2023年10月', desc: '公司正式成立，开启AI语音应用赛道布局' }
    ],
    teamTitle: '核心团队',
    teamSub: '十多年团队运营经验 + 资深AI技术团队 + 深度交付',
    teamMembers: [
      {
        name: '王汉生',
        post: '合伙人',
        desc: '北京大学光华管理学院教授 博士生导师\n教育部长江学者特聘教授\n国内最早从统计数据分析角度关注并研究搜索引擎营销，社交网络数据，以及位置轨迹数据分析的学者'
      },
      {
        name: '白雪峰',
        post: '创始人',
        desc: '中国传媒大学硕士、北京大学光华管理学院EMBA\n拥有近二十年的团队运营管理经验\n对传统人工电销及传统AI局限性具有深入性了解\n为AI在企业级市场落地提供战略方向'
      },
      {
        name: '潘蕊',
        post: '算法总监',
        desc: '中央财经大学统计与数学学院教授、博士生导师\n中央财经大学龙马学者青年学者\n主要研究领域为网络结构数据的统计建模、时空数据的统计分析等'
      },
      {
        name: '技术团队',
        post: '算法团队',
        desc: '来自北京大学、中国人民大学、中央财经大学等顶尖学府的高水平算法团队8名博士、10余名硕士\n团队在大语言模型、核心算法及软件开发等领域具备深厚积淀与前沿探索能力'
      }
    ]
  }
}



// WEBPACK FOOTER //
// ./src/i18n/zh.js